// extracted by mini-css-extract-plugin
export default {"btn":"subscribe-modal-button-module__btn--fjipN"};